// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== CSS Variables ========== */
:root {
    --primary-50: #faf5ff;
    --primary-100: #f3e8ff;
    --primary-200: #e9d5ff;
    --primary-300: #d8b4fe;
    --primary-400: #c084fc;
    --primary-500: #a855f7;
    --primary-600: #9333ea;
    --primary-700: #7e22ce;
    --primary-800: #6b21a8;
    --primary-900: #581c87;

    --partner-primary-50: #f0f9ff;
    --partner-primary-100: #e0f2fe;
    --partner-primary-200: #bae6fd;
    --partner-primary-300: #7dd3fc;
    --partner-primary-400: #38bdf8;
    --partner-primary-500: #0ea5e9;
    --partner-primary-600: #0284c7;
    --partner-primary-700: #0369a1;
    --partner-primary-800: #075985;
    --partner-primary-900: #0c4a6e;

    --gray-50: #f8fafc;
    --gray-100: #f1f5f9;
    --gray-200: #e2e8f0;
    --gray-300: #cbd5e1;
    --gray-400: #94a3b8;
    --gray-500: #64748b;
    --gray-600: #475569;
    --gray-700: #334155;
    --gray-800: #1e293b;
    --gray-900: #0f172a;

    --success: #10b981;
    --success-light: #d1fae5;
    --warning: #f59e0b;
    --warning-light: #fef3c7;
    --error: #ef4444;
    --error-light: #fee2e2;
    --info: #3b82f6;
    --info-light: #dbeafe;

    --background: #ffffff;
    --surface: #f8fafc;
    --border: #e2e8f0;
    --text-primary: #0f172a;
    --text-secondary: #475569;
    --text-tertiary: #94a3b8;

    --gpt-color: #10a37f;
    --gpt-bg: #ecfdf5;
    --gpt35-color: #19c37d;
    --gpt4o-color: #10a37f;
    --gpt5-color: #0d8c6c;
    --claude-color: #d97757;
    --claude-bg: #fff7ed;
    --gemini-color: #4285f4;
    --gemini-bg: #eff6ff;
    --exaone-color: #a50034;
    --exaone-bg: #fdf2f8;
    --friendli-color: #a50034;
    --friendli-bg: #fdf2f8;
    --meta-color: #1877F2;
    --meta-bg: #eff6ff;
    --stepfun-color: #EC4899;
    --stepfun-bg: #fdf2f8;
    --upstage-color: #F59E0B;
    --upstage-bg: #fefce8;
    --nvidia-color: #76B900;
    --nvidia-bg: #f0fce8;
    --arcee-color: #06B6D4;
    --arcee-bg: #ecfeff;
    --qwen-color: #7C3AED;
    --qwen-bg: #f5f3ff;
    --mistral-color: #FF7000;
    --mistral-bg: #fff4e6;
    --deepseek-color: #4338CA;
    --deepseek-bg: #eef2ff;

    --sidebar-width: 260px;
    --sidebar-collapsed-width: 64px;
    --right-panel-width: 320px;
    --header-height: 56px;
    --font-sans: "Pretendard", "Noto Sans KR", -apple-system, BlinkMacSystemFont, "Apple SD Gothic Neo", sans-serif;
    --radius-sm: 4px;
    --radius-md: 6px;
    --radius-lg: 8px;
    --radius-xl: 8px;
    --radius-2xl: 12px;
    --radius-full: 9999px;
    --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.04);
    --shadow-md: 0 2px 4px rgba(0, 0, 0, 0.06);
    --shadow-lg: 0 4px 8px rgba(0, 0, 0, 0.08);
    --shadow-xl: 0 8px 16px rgba(0, 0, 0, 0.1);
    --shadow-2xl: 0 12px 24px rgba(0, 0, 0, 0.12);
    --transition-fast: 0.15s ease;
    --focus-ring: 0 0 0 2px var(--primary-200);

    --error-dark: #dc2626;
    --success-dark: #059669;
    --warning-border: #fcd34d;
    --warning-text: #92400e;

    --notice-bg: #f5f3ff;
    --notice-border: #7c3aed;
    --notice-title: #5b21b6;
    --notice-text: #6d28d9;

    --error-alert-bg: #fef2f2;
    --error-alert-border: #fecaca;
    --error-alert-text: #991b1b;

    /* ─── 신규 디자인 토큰 (Figma GrowFit 2026-04 시안) ─── */
    --fg-bg-dark: #2f3247;
    --fg-bg-content: #f2f2f2;
    --fg-bg-card: #fbfbfb;
    --fg-bg-header-hover: #4e5169;
    --fg-bg-toolbox: #4a4d5d;
    --fg-bg-toolbox-elev: #353743;
    --fg-yellow: #ffd900;
    --fg-orange-warn: #ff7700;
    --fg-cyan-bar: #a3eaf6;
    --fg-text-menu: #bdbdbd;
    --fg-line: #dbdbdb;
    --fg-checkbox-off: #c2c2c2;
    --fg-text-basic: #3b3b3b;
    --fg-text-gray: #838383;
    --fg-anti-red: #ff1500;
    --fg-button: #978cca;
    --fg-button-hover: #7362c2;
    --fg-bg-liteblue: #f6f8ff;
    --fg-bg-litepp: #e8eaf5;
    --fg-bg-litepp-hover: #cbd1ef;
    --fg-bg-warm: #fff4ee;
    --fg-bg-cool: #f2ffff;
    --fg-bg-cooler: #f8ffff;
    --fg-bg-warning: #ffe8db;
    --fg-bg-mychat: #e5e7f3;
    --fg-text-menu-current: #ffffff;
    --fg-text-purple: #7362c2;
    --fg-bg-toolbar: #f4f5fb;
    --fg-link: #2c95f8;
    --fg-link-hover: #036ed3;
    --fg-blue-lite: #86b6f3;
    --fg-emr-green: #82d3d5;
    --fg-side-hover: #4c5ed9;
    --fg-class-green: #629351;
    --fg-numbering-bg: #82d9e8;
    --fg-numbering-bg-current: #1cc3e9;
    --fg-bg-stepper-inactive: #f8f8f8;
    --fg-bg-tag-lime: #dff0c4;
    --fg-bg-step-active: #f3f4ff;
    --fg-bg-fewshot: #f4f6ff;
    --fg-bg-vs-blue: #e8f1ff;
    --fg-bg-vs-green: #e5f9dc;
    --fg-bg-publishing: #b9f0d6;
    --fg-text-publishing: #137a4d;
    --fg-bg-connected: #f3ffff;
    --fg-bg-connect-on: #aaf054;
}

[data-theme="dark"] {
    color-scheme: dark;

    --background: #0f172a;
    --surface: #1e293b;
    --border: #334155;
    --text-primary: #f1f5f9;
    --text-secondary: #94a3b8;
    --text-tertiary: #64748b;

    --gray-50: #1e293b;
    --gray-100: #334155;
    --gray-200: #475569;
    --gray-300: #64748b;
    --gray-400: #94a3b8;
    --gray-500: #cbd5e1;
    --gray-600: #e2e8f0;
    --gray-700: #f1f5f9;
    --gray-800: #f8fafc;
    --gray-900: #ffffff;

    --primary-50: #1a1033;
    --primary-100: #2e1065;
    --primary-200: #4c1d95;
    --primary-300: #6d28d9;
    --primary-400: #8b5cf6;
    --primary-500: #a78bfa;
    --primary-600: #a855f7;
    --primary-700: #c084fc;
    --primary-800: #d8b4fe;
    --primary-900: #e9d5ff;

    --partner-primary-50: #0c2d48;
    --partner-primary-100: #0e3a5e;
    --partner-primary-200: #0f4c75;
    --partner-primary-300: #38bdf8;
    --partner-primary-400: #7dd3fc;
    --partner-primary-500: #38bdf8;
    --partner-primary-600: #7dd3fc;
    --partner-primary-700: #bae6fd;
    --partner-primary-800: #e0f2fe;
    --partner-primary-900: #f0f9ff;

    --success-light: #064e3b;
    --warning-light: #78350f;
    --error-light: #7f1d1d;
    --info-light: #1e3a5f;

    --error-dark: #f87171;
    --success-dark: #34d399;
    --warning-border: #92400e;
    --warning-text: #fcd34d;

    --notice-bg: #1e1033;
    --notice-border: #8b5cf6;
    --notice-title: #c4b5fd;
    --notice-text: #a78bfa;

    --error-alert-bg: #450a0a;
    --error-alert-border: #7f1d1d;
    --error-alert-text: #fca5a5;

    --gpt-bg: #064e3b;
    --claude-bg: #431407;
    --gemini-bg: #1e3a5f;
    --exaone-bg: #4a0019;
    --friendli-bg: #4a0019;
    --meta-bg: #1e3a6e;
    --stepfun-bg: #500724;
    --upstage-bg: #713f12;
    --nvidia-bg: #2d4a00;
    --arcee-bg: #164e63;
    --qwen-bg: #2e1065;
    --mistral-bg: #5c2900;
    --deepseek-bg: #1e1b4b;

    --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.15);
    --shadow-md: 0 2px 4px rgba(0, 0, 0, 0.2);
    --shadow-lg: 0 4px 8px rgba(0, 0, 0, 0.25);
    --shadow-xl: 0 8px 16px rgba(0, 0, 0, 0.3);
    --shadow-2xl: 0 12px 24px rgba(0, 0, 0, 0.35);
}

/* 일반 클래스 옅은 갈색 테마 (MUJI Soft Olive) */
[data-plan="class"] {
    --primary-50: rgba(139,115,85,0.04);
    --primary-100: rgba(139,115,85,0.08);
    --primary-200: rgba(139,115,85,0.12);
    --primary-300: rgba(139,115,85,0.25);
    --primary-400: rgba(139,115,85,0.45);
    --primary-500: #8B7355;
    --primary-600: #8B7355;
    --primary-700: #6B5A42;
    --primary-800: #4A3E2E;
    --primary-900: #2F2A24;
}

[data-plan="class"][data-theme="dark"] {
    --primary-50: #1e1b17;
    --primary-100: #2d2820;
    --primary-200: #3d3630;
    --primary-300: #5a5040;
    --primary-400: #7a6d55;
    --primary-500: #a08e70;
    --primary-600: #b8a488;
    --primary-700: #c6b6a4;
    --primary-800: #dbd0c2;
    --primary-900: #f0e8e0;
}

/* 개인 플랜 짙은 갈색 테마 */
[data-plan="basic"] {
    --primary-50: #f9f3ed;
    --primary-100: #ecdccf;
    --primary-200: #dcc5b0;
    --primary-300: #c0a080;
    --primary-400: #9b7555;
    --primary-500: #7a5635;
    --primary-600: #5e3d1e;
    --primary-700: #4a3018;
    --primary-800: #3b2612;
    --primary-900: #2f1e0e;
}

[data-plan="basic"][data-theme="dark"] {
    --primary-50: #251c15;
    --primary-100: #382a1e;
    --primary-200: #4a3828;
    --primary-300: #6b5240;
    --primary-400: #8b6e55;
    --primary-500: #a68870;
    --primary-600: #c4a68e;
    --primary-700: #d4bba8;
    --primary-800: #e4d0c0;
    --primary-900: #f2e8e0;
}

html.theme-transitioning *,
html.theme-transitioning *::before,
html.theme-transitioning *::after {
    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;
}

/* ─── Admin Light Theme Tokens ─── */
.admin {
  --admin-bg: #f8fafc;
  --admin-surface: #ffffff;
  --admin-surface-hover: #f1f5f9;
  --admin-border: #e2e8f0;
  --admin-border-light: rgba(226,232,240,0.6);
  --admin-text-bright: #0f172a;
  --admin-text-primary: #1e293b;
  --admin-text-secondary: #475569;
  --admin-text-muted: #94a3b8;
  --admin-text-dim: #cbd5e1;

  --admin-accent: #a78bfa;
  --admin-accent-hover: #8b5cf6;
  --admin-accent-bg: rgba(167,139,250,0.08);
  --admin-accent-bg-hover: rgba(167,139,250,0.12);

  --admin-success: #16a34a;
  --admin-success-bg: rgba(22,163,74,0.08);
  --admin-warning: #ea580c;
  --admin-warning-bg: rgba(234,88,12,0.08);
  --admin-error: #dc2626;
  --admin-error-bg: rgba(220,38,38,0.08);
  --admin-info: #0891b2;
  --admin-info-bg: rgba(8,145,178,0.08);

  --admin-shadow-dropdown: 0 4px 24px rgba(0,0,0,0.08);
  --admin-shadow-modal: 0 8px 32px rgba(0,0,0,0.12);

  --admin-radius-sm: 6px;
  --admin-radius-md: 8px;
  --admin-radius-lg: 12px;
  --admin-radius-xl: 16px;

  --admin-font-body: 'Pretendard', -apple-system, sans-serif;
  --admin-font-mono: 'JetBrains Mono', 'Fira Code', monospace;
}

`, "",{"version":3,"sources":["webpack://./src/css/variables.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;IACI,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;;IAEtB,6BAA6B;IAC7B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;;IAE9B,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;;IAEnB,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,qBAAqB;;IAErB,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,yBAAyB;IACzB,wBAAwB;;IAExB,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;IACpB,uBAAuB;IACvB,oBAAoB;IACpB,uBAAuB;IACvB,oBAAoB;IACpB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;IACrB,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;;IAEtB,sBAAsB;IACtB,+BAA+B;IAC/B,0BAA0B;IAC1B,qBAAqB;IACrB,+GAA+G;IAC/G,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,6CAA6C;IAC7C,6BAA6B;IAC7B,0CAA0C;;IAE1C,qBAAqB;IACrB,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;;IAEvB,oBAAoB;IACpB,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;;IAEtB,yBAAyB;IACzB,6BAA6B;IAC7B,2BAA2B;;IAE3B,iDAAiD;IACjD,qBAAqB;IACrB,wBAAwB;IACxB,qBAAqB;IACrB,6BAA6B;IAC7B,wBAAwB;IACxB,6BAA6B;IAC7B,oBAAoB;IACpB,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,0BAA0B;IAC1B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,oBAAoB;IACpB,0BAA0B;IAC1B,yBAAyB;IACzB,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;IACvB,+BAA+B;IAC/B,yBAAyB;IACzB,wBAAwB;IACxB,kBAAkB;IAClB,wBAAwB;IACxB,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;IACzB,0BAA0B;IAC1B,kCAAkC;IAClC,iCAAiC;IACjC,yBAAyB;IACzB,4BAA4B;IAC5B,wBAAwB;IACxB,wBAAwB;IACxB,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;;IAElB,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,yBAAyB;IACzB,wBAAwB;;IAExB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;;IAEnB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;;IAEtB,6BAA6B;IAC7B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;IAC9B,8BAA8B;;IAE9B,wBAAwB;IACxB,wBAAwB;IACxB,sBAAsB;IACtB,qBAAqB;;IAErB,qBAAqB;IACrB,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;;IAEvB,oBAAoB;IACpB,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;;IAEtB,yBAAyB;IACzB,6BAA6B;IAC7B,2BAA2B;;IAE3B,iBAAiB;IACjB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;;IAEtB,0CAA0C;IAC1C,yCAAyC;IACzC,0CAA0C;IAC1C,0CAA0C;IAC1C,6CAA6C;AACjD;;AAEA,sCAAsC;AACtC;IACI,mCAAmC;IACnC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA,mBAAmB;AACnB;IACI,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;;;IAGI,gHAAgH;AACpH;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,2CAA2C;EAC3C,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;;EAEzB,uBAAuB;EACvB,6BAA6B;EAC7B,yCAAyC;EACzC,+CAA+C;;EAE/C,wBAAwB;EACxB,wCAAwC;EACxC,wBAAwB;EACxB,wCAAwC;EACxC,sBAAsB;EACtB,sCAAsC;EACtC,qBAAqB;EACrB,qCAAqC;;EAErC,oDAAoD;EACpD,iDAAiD;;EAEjD,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;;EAEvB,0DAA0D;EAC1D,2DAA2D;AAC7D","sourcesContent":["/* ========== CSS Variables ========== */\n:root {\n    --primary-50: #faf5ff;\n    --primary-100: #f3e8ff;\n    --primary-200: #e9d5ff;\n    --primary-300: #d8b4fe;\n    --primary-400: #c084fc;\n    --primary-500: #a855f7;\n    --primary-600: #9333ea;\n    --primary-700: #7e22ce;\n    --primary-800: #6b21a8;\n    --primary-900: #581c87;\n\n    --partner-primary-50: #f0f9ff;\n    --partner-primary-100: #e0f2fe;\n    --partner-primary-200: #bae6fd;\n    --partner-primary-300: #7dd3fc;\n    --partner-primary-400: #38bdf8;\n    --partner-primary-500: #0ea5e9;\n    --partner-primary-600: #0284c7;\n    --partner-primary-700: #0369a1;\n    --partner-primary-800: #075985;\n    --partner-primary-900: #0c4a6e;\n\n    --gray-50: #f8fafc;\n    --gray-100: #f1f5f9;\n    --gray-200: #e2e8f0;\n    --gray-300: #cbd5e1;\n    --gray-400: #94a3b8;\n    --gray-500: #64748b;\n    --gray-600: #475569;\n    --gray-700: #334155;\n    --gray-800: #1e293b;\n    --gray-900: #0f172a;\n\n    --success: #10b981;\n    --success-light: #d1fae5;\n    --warning: #f59e0b;\n    --warning-light: #fef3c7;\n    --error: #ef4444;\n    --error-light: #fee2e2;\n    --info: #3b82f6;\n    --info-light: #dbeafe;\n\n    --background: #ffffff;\n    --surface: #f8fafc;\n    --border: #e2e8f0;\n    --text-primary: #0f172a;\n    --text-secondary: #475569;\n    --text-tertiary: #94a3b8;\n\n    --gpt-color: #10a37f;\n    --gpt-bg: #ecfdf5;\n    --gpt35-color: #19c37d;\n    --gpt4o-color: #10a37f;\n    --gpt5-color: #0d8c6c;\n    --claude-color: #d97757;\n    --claude-bg: #fff7ed;\n    --gemini-color: #4285f4;\n    --gemini-bg: #eff6ff;\n    --exaone-color: #a50034;\n    --exaone-bg: #fdf2f8;\n    --friendli-color: #a50034;\n    --friendli-bg: #fdf2f8;\n    --meta-color: #1877F2;\n    --meta-bg: #eff6ff;\n    --stepfun-color: #EC4899;\n    --stepfun-bg: #fdf2f8;\n    --upstage-color: #F59E0B;\n    --upstage-bg: #fefce8;\n    --nvidia-color: #76B900;\n    --nvidia-bg: #f0fce8;\n    --arcee-color: #06B6D4;\n    --arcee-bg: #ecfeff;\n    --qwen-color: #7C3AED;\n    --qwen-bg: #f5f3ff;\n    --mistral-color: #FF7000;\n    --mistral-bg: #fff4e6;\n    --deepseek-color: #4338CA;\n    --deepseek-bg: #eef2ff;\n\n    --sidebar-width: 260px;\n    --sidebar-collapsed-width: 64px;\n    --right-panel-width: 320px;\n    --header-height: 56px;\n    --font-sans: \"Pretendard\", \"Noto Sans KR\", -apple-system, BlinkMacSystemFont, \"Apple SD Gothic Neo\", sans-serif;\n    --radius-sm: 4px;\n    --radius-md: 6px;\n    --radius-lg: 8px;\n    --radius-xl: 8px;\n    --radius-2xl: 12px;\n    --radius-full: 9999px;\n    --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.04);\n    --shadow-md: 0 2px 4px rgba(0, 0, 0, 0.06);\n    --shadow-lg: 0 4px 8px rgba(0, 0, 0, 0.08);\n    --shadow-xl: 0 8px 16px rgba(0, 0, 0, 0.1);\n    --shadow-2xl: 0 12px 24px rgba(0, 0, 0, 0.12);\n    --transition-fast: 0.15s ease;\n    --focus-ring: 0 0 0 2px var(--primary-200);\n\n    --error-dark: #dc2626;\n    --success-dark: #059669;\n    --warning-border: #fcd34d;\n    --warning-text: #92400e;\n\n    --notice-bg: #f5f3ff;\n    --notice-border: #7c3aed;\n    --notice-title: #5b21b6;\n    --notice-text: #6d28d9;\n\n    --error-alert-bg: #fef2f2;\n    --error-alert-border: #fecaca;\n    --error-alert-text: #991b1b;\n\n    /* ─── 신규 디자인 토큰 (Figma GrowFit 2026-04 시안) ─── */\n    --fg-bg-dark: #2f3247;\n    --fg-bg-content: #f2f2f2;\n    --fg-bg-card: #fbfbfb;\n    --fg-bg-header-hover: #4e5169;\n    --fg-bg-toolbox: #4a4d5d;\n    --fg-bg-toolbox-elev: #353743;\n    --fg-yellow: #ffd900;\n    --fg-orange-warn: #ff7700;\n    --fg-cyan-bar: #a3eaf6;\n    --fg-text-menu: #bdbdbd;\n    --fg-line: #dbdbdb;\n    --fg-checkbox-off: #c2c2c2;\n    --fg-text-basic: #3b3b3b;\n    --fg-text-gray: #838383;\n    --fg-anti-red: #ff1500;\n    --fg-button: #978cca;\n    --fg-button-hover: #7362c2;\n    --fg-bg-liteblue: #f6f8ff;\n    --fg-bg-litepp: #e8eaf5;\n    --fg-bg-litepp-hover: #cbd1ef;\n    --fg-bg-warm: #fff4ee;\n    --fg-bg-cool: #f2ffff;\n    --fg-bg-cooler: #f8ffff;\n    --fg-bg-warning: #ffe8db;\n    --fg-bg-mychat: #e5e7f3;\n    --fg-text-menu-current: #ffffff;\n    --fg-text-purple: #7362c2;\n    --fg-bg-toolbar: #f4f5fb;\n    --fg-link: #2c95f8;\n    --fg-link-hover: #036ed3;\n    --fg-blue-lite: #86b6f3;\n    --fg-emr-green: #82d3d5;\n    --fg-side-hover: #4c5ed9;\n    --fg-class-green: #629351;\n    --fg-numbering-bg: #82d9e8;\n    --fg-numbering-bg-current: #1cc3e9;\n    --fg-bg-stepper-inactive: #f8f8f8;\n    --fg-bg-tag-lime: #dff0c4;\n    --fg-bg-step-active: #f3f4ff;\n    --fg-bg-fewshot: #f4f6ff;\n    --fg-bg-vs-blue: #e8f1ff;\n    --fg-bg-vs-green: #e5f9dc;\n    --fg-bg-publishing: #b9f0d6;\n    --fg-text-publishing: #137a4d;\n    --fg-bg-connected: #f3ffff;\n    --fg-bg-connect-on: #aaf054;\n}\n\n[data-theme=\"dark\"] {\n    color-scheme: dark;\n\n    --background: #0f172a;\n    --surface: #1e293b;\n    --border: #334155;\n    --text-primary: #f1f5f9;\n    --text-secondary: #94a3b8;\n    --text-tertiary: #64748b;\n\n    --gray-50: #1e293b;\n    --gray-100: #334155;\n    --gray-200: #475569;\n    --gray-300: #64748b;\n    --gray-400: #94a3b8;\n    --gray-500: #cbd5e1;\n    --gray-600: #e2e8f0;\n    --gray-700: #f1f5f9;\n    --gray-800: #f8fafc;\n    --gray-900: #ffffff;\n\n    --primary-50: #1a1033;\n    --primary-100: #2e1065;\n    --primary-200: #4c1d95;\n    --primary-300: #6d28d9;\n    --primary-400: #8b5cf6;\n    --primary-500: #a78bfa;\n    --primary-600: #a855f7;\n    --primary-700: #c084fc;\n    --primary-800: #d8b4fe;\n    --primary-900: #e9d5ff;\n\n    --partner-primary-50: #0c2d48;\n    --partner-primary-100: #0e3a5e;\n    --partner-primary-200: #0f4c75;\n    --partner-primary-300: #38bdf8;\n    --partner-primary-400: #7dd3fc;\n    --partner-primary-500: #38bdf8;\n    --partner-primary-600: #7dd3fc;\n    --partner-primary-700: #bae6fd;\n    --partner-primary-800: #e0f2fe;\n    --partner-primary-900: #f0f9ff;\n\n    --success-light: #064e3b;\n    --warning-light: #78350f;\n    --error-light: #7f1d1d;\n    --info-light: #1e3a5f;\n\n    --error-dark: #f87171;\n    --success-dark: #34d399;\n    --warning-border: #92400e;\n    --warning-text: #fcd34d;\n\n    --notice-bg: #1e1033;\n    --notice-border: #8b5cf6;\n    --notice-title: #c4b5fd;\n    --notice-text: #a78bfa;\n\n    --error-alert-bg: #450a0a;\n    --error-alert-border: #7f1d1d;\n    --error-alert-text: #fca5a5;\n\n    --gpt-bg: #064e3b;\n    --claude-bg: #431407;\n    --gemini-bg: #1e3a5f;\n    --exaone-bg: #4a0019;\n    --friendli-bg: #4a0019;\n    --meta-bg: #1e3a6e;\n    --stepfun-bg: #500724;\n    --upstage-bg: #713f12;\n    --nvidia-bg: #2d4a00;\n    --arcee-bg: #164e63;\n    --qwen-bg: #2e1065;\n    --mistral-bg: #5c2900;\n    --deepseek-bg: #1e1b4b;\n\n    --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.15);\n    --shadow-md: 0 2px 4px rgba(0, 0, 0, 0.2);\n    --shadow-lg: 0 4px 8px rgba(0, 0, 0, 0.25);\n    --shadow-xl: 0 8px 16px rgba(0, 0, 0, 0.3);\n    --shadow-2xl: 0 12px 24px rgba(0, 0, 0, 0.35);\n}\n\n/* 일반 클래스 옅은 갈색 테마 (MUJI Soft Olive) */\n[data-plan=\"class\"] {\n    --primary-50: rgba(139,115,85,0.04);\n    --primary-100: rgba(139,115,85,0.08);\n    --primary-200: rgba(139,115,85,0.12);\n    --primary-300: rgba(139,115,85,0.25);\n    --primary-400: rgba(139,115,85,0.45);\n    --primary-500: #8B7355;\n    --primary-600: #8B7355;\n    --primary-700: #6B5A42;\n    --primary-800: #4A3E2E;\n    --primary-900: #2F2A24;\n}\n\n[data-plan=\"class\"][data-theme=\"dark\"] {\n    --primary-50: #1e1b17;\n    --primary-100: #2d2820;\n    --primary-200: #3d3630;\n    --primary-300: #5a5040;\n    --primary-400: #7a6d55;\n    --primary-500: #a08e70;\n    --primary-600: #b8a488;\n    --primary-700: #c6b6a4;\n    --primary-800: #dbd0c2;\n    --primary-900: #f0e8e0;\n}\n\n/* 개인 플랜 짙은 갈색 테마 */\n[data-plan=\"basic\"] {\n    --primary-50: #f9f3ed;\n    --primary-100: #ecdccf;\n    --primary-200: #dcc5b0;\n    --primary-300: #c0a080;\n    --primary-400: #9b7555;\n    --primary-500: #7a5635;\n    --primary-600: #5e3d1e;\n    --primary-700: #4a3018;\n    --primary-800: #3b2612;\n    --primary-900: #2f1e0e;\n}\n\n[data-plan=\"basic\"][data-theme=\"dark\"] {\n    --primary-50: #251c15;\n    --primary-100: #382a1e;\n    --primary-200: #4a3828;\n    --primary-300: #6b5240;\n    --primary-400: #8b6e55;\n    --primary-500: #a68870;\n    --primary-600: #c4a68e;\n    --primary-700: #d4bba8;\n    --primary-800: #e4d0c0;\n    --primary-900: #f2e8e0;\n}\n\nhtml.theme-transitioning *,\nhtml.theme-transitioning *::before,\nhtml.theme-transitioning *::after {\n    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;\n}\n\n/* ─── Admin Light Theme Tokens ─── */\n.admin {\n  --admin-bg: #f8fafc;\n  --admin-surface: #ffffff;\n  --admin-surface-hover: #f1f5f9;\n  --admin-border: #e2e8f0;\n  --admin-border-light: rgba(226,232,240,0.6);\n  --admin-text-bright: #0f172a;\n  --admin-text-primary: #1e293b;\n  --admin-text-secondary: #475569;\n  --admin-text-muted: #94a3b8;\n  --admin-text-dim: #cbd5e1;\n\n  --admin-accent: #a78bfa;\n  --admin-accent-hover: #8b5cf6;\n  --admin-accent-bg: rgba(167,139,250,0.08);\n  --admin-accent-bg-hover: rgba(167,139,250,0.12);\n\n  --admin-success: #16a34a;\n  --admin-success-bg: rgba(22,163,74,0.08);\n  --admin-warning: #ea580c;\n  --admin-warning-bg: rgba(234,88,12,0.08);\n  --admin-error: #dc2626;\n  --admin-error-bg: rgba(220,38,38,0.08);\n  --admin-info: #0891b2;\n  --admin-info-bg: rgba(8,145,178,0.08);\n\n  --admin-shadow-dropdown: 0 4px 24px rgba(0,0,0,0.08);\n  --admin-shadow-modal: 0 8px 32px rgba(0,0,0,0.12);\n\n  --admin-radius-sm: 6px;\n  --admin-radius-md: 8px;\n  --admin-radius-lg: 12px;\n  --admin-radius-xl: 16px;\n\n  --admin-font-body: 'Pretendard', -apple-system, sans-serif;\n  --admin-font-mono: 'JetBrains Mono', 'Fira Code', monospace;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
